import { render, staticRenderFns } from "./MyCourseCardSmall.vue?vue&type=template&id=69114f36&scoped=true"
import script from "./MyCourseCardSmall.vue?vue&type=script&lang=js"
export * from "./MyCourseCardSmall.vue?vue&type=script&lang=js"
import style0 from "./MyCourseCardSmall.vue?vue&type=style&index=0&id=69114f36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69114f36",
  null
  
)

export default component.exports